const PAGE_GUIDE_ROUTES = [
    { prefix: '/specifications', pageKey: 'specifications' },
    { prefix: '/components', pageKey: 'components' },
    { prefix: '/suppliers', pageKey: 'suppliers' },
    { prefix: '/inbox', pageKey: 'inbox' },
    { prefix: '/orders', pageKey: 'orders' },
    { prefix: '/warehouse-releases', pageKey: 'warehouseReleases' },
    { prefix: '/order-operators', pageKey: 'orderOperators' },
    { prefix: '/manufacturers', pageKey: 'manufacturers' },
];
const getPageGuideKey = (pathname) => {
    var _a;
    const match = PAGE_GUIDE_ROUTES.find((route) => pathname.startsWith(route.prefix));
    return (_a = match === null || match === void 0 ? void 0 : match.pageKey) !== null && _a !== void 0 ? _a : null;
};
export default getPageGuideKey;
